import { isIOS } from 'react-device-detect'

const VIDEO_CLASSNAME = 'video'

export const getElementById = (id: string) => {
  return document.getElementById(id)!
}

// 拡大防止
export const preventMobileScroll = (e: TouchEvent) => {
  if (e.touches.length >= 2) {
    e.preventDefault()
  }
}

// for ios
export const playBackgroundVideo = () => {
  const isHidden = document.hidden
  if (isHidden) return

  const videos = document.getElementsByClassName(
    VIDEO_CLASSNAME
  ) as HTMLCollectionOf<HTMLVideoElement>
  for (let i = 0; i < videos.length; i++) {
    if (videos[i].style.visibility === 'visible') {
      if (videos[i].paused) videos[i].play()
      break
    }
  }
}

export const isIOSAndPWA = () => {
  return (
    isIOS &&
    (window.matchMedia('(display-mode: standalone)').matches ||
      ('standalone' in window.navigator && window.navigator['standalone']))
  )
}
